import React, { Suspense, Fragment, lazy, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Layout from "./components/common/Layout";
import Authenticated from "./Guard/Authenticated";
import ReactGA from "react-ga4";

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ 
      hitType: "pageview", 
      page: location.pathname + location.search,
      title: document.title
    });
    
    console.log(`GA4 Pageview: ${location.pathname}`);
  }, [location]);

  return null;
};

export function RenderRout() {
  return (
    <>
      <Router>
        <RouteTracker />
        <Suspense fallback={
          <div className="text-center my-5">
            <div className="spinner-border text-primary" role="status">
            </div>
          </div>
        }>
          <Routes>
            {routes?.map((route, i) => {
              const Guard = route?.guard || Fragment;
              const Auth = route?.auth || Fragment;
              const Layout = route?.Layout || Fragment;
              const Component = route?.element;
              return (
                <Route
                  key={i}
                  path={route.path}
                  exact={route.exact}
                  element={
                    <Guard>
                      <Auth>
                        <Layout>
                          <Component />
                        </Layout>
                      </Auth>
                    </Guard>
                  }
                />
              );
            })}
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

const routes = [
  {
    exact: true,
    path: "/",
    element: lazy(() => import("./components/pages/Landing/Index")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/home",
    element: lazy(() => import("./components/pages/home/Index")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/generate-logo",
    element: lazy(() => import("./components/pages/generate-logo/Index")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/choose-item-option",
    element: lazy(() => import("./components/pages/choose-item-option/Index")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/product-detail/:id",
    element: lazy(() => import("./components/pages/product-detail/Index")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/product-customize/:id?",
    element: lazy(() => import("./components/pages/customization/ProductCustomize")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/cart-details",
    element: lazy(() => import("./components/pages/cart-detail/Index")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/checkout",
    element: lazy(() => import("./components/pages/checkout/Index")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/order-success",
    element: lazy(() => import("./components/pages/checkout/OrderSuccess")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/dashboard",
    element: lazy(() => import("./components/pages/dashboard/Index")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/about",
    element: lazy(() => import("./components/common/About")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/contact",
    element: lazy(() => import("./components/common/Contact")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/faq",
    element: lazy(() => import("./components/common/Faqquestion")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/privacy-policy",
    element: lazy(() => import("./components/common/Privacy")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/terms-conditions",
    element: lazy(() => import("./components/common/Termcondition")),
  },
  {
    Layout: Layout,
    exact: true,
    path: "/categories",
    element: lazy(() => import("./components/pages/category/List")),
  },
  ///404 Page
  {

    exact: true,
    path: '*',
    element: lazy(() => import('./components/pages/PageNotFound/PageNotFound'))
  }
];
